import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faDownload,
  faExclamationCircle,
} from '@fortawesome/sharp-regular-svg-icons'
import { Button } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import React from 'react'

import {
  downLoadReceivedBlob,
  useRequestBlob,
} from '../../../hooks/useRequestBlob'

type DownloadJobFilesProps = {
  completed: boolean
  jobId: number
  file_name: string
}

const DownloadJobFiles = ({
  completed,
  jobId,
  file_name,
}: DownloadJobFilesProps): React.ReactElement => {
  let nameWithoutExtension = file_name.split('.').slice(0, -1).join('.')
  if (!nameWithoutExtension) nameWithoutExtension = file_name

  const requestBlobMutation = useRequestBlob({
    onSuccess: (blob) => {
      downLoadReceivedBlob({
        blob,
        name: `${nameWithoutExtension}.zip`,
      })
    },
    onError: () => {
      showNotification({
        color: 'red',
        title: i18n.t('noti_title_failure', `Oops!`),
        message: i18n.t(
          'error_downloading_order_label_files',
          'Labels konnten nicht heruntergeladen werden.',
        ),
        icon: <FontAwesomeIcon icon={faExclamationCircle} />,
      })
    },
  })

  if (!completed) return <></>

  return (
    <Button
      variant="light"
      size="xs"
      loading={requestBlobMutation.isPending}
      leftIcon={<FontAwesomeIcon icon={faDownload} />}
      onClick={() =>
        requestBlobMutation.mutate({
          method: 'GET',
          postBody: {},
          url: `/api/order-jobs/download/${jobId}`,
        })
      }
    >
      {i18n.t('download_job_files', 'Herunterladen')}
    </Button>
  )
}

export default DownloadJobFiles
